import { Link } from "react-router";
import { Aviso, Celula, CelulaCabecalho, Cabecalho, Corpo, Linha, Tabela } from "../ui";
import { mensagemDoConsole } from "../../nucleo/console";
import { formatarInstante } from "../../nucleo/cofre";
import { situacaoDoItem, useDetalheDoNumero } from "../../nucleo/paineis";
import type { FiltrosGuardados } from "../../nucleo/paineis";

interface Props {
  tipo: string;
  numero: string;
  filtros: FiltrosGuardados;
}

/**
 * Os chamados que compõem um número do painel. A lista vem do servidor, do mesmo serviço e do
 * mesmo recorte que gerou o número — esta tela não recorta nada por conta própria.
 *
 * Onde o número não nasce de chamado (a deflexão da base de conhecimento conta leituras de
 * artigo), a linha é o registro que o compõe, sem link, e o servidor explica o porquê na nota.
 */
export function DrillDoNumero({ tipo, numero, filtros }: Props) {
  const detalhe = useDetalheDoNumero(tipo, numero, filtros);

  if (detalhe.isPending) return <p role="status">Abrindo os chamados…</p>;
  if (detalhe.isError) return <Aviso tom="erro">{mensagemDoConsole(detalhe.error)}</Aviso>;

  const { rotulo, total, itens, nota } = detalhe.data;
  return (
    <div className="mt-3" data-testid="drill-do-numero">
      <p className="nota-rodape mb-2">
        {rotulo}: {total} {total === 1 ? "registro" : "registros"}
      </p>
      {nota ? (
        <Aviso tom="neutro" className="mb-2">
          {nota}
        </Aviso>
      ) : null}
      {itens.length === 0 ? (
        <p className="cartao__texto">Nada compõe este número agora.</p>
      ) : (
        <Tabela legenda={`${rotulo}: chamados que compõem o número`}>
          <Cabecalho>
            <Linha>
              <CelulaCabecalho>Chamado</CelulaCabecalho>
              <CelulaCabecalho>Empresa</CelulaCabecalho>
              <CelulaCabecalho>Situação</CelulaCabecalho>
              <CelulaCabecalho>Quando</CelulaCabecalho>
            </Linha>
          </Cabecalho>
          <Corpo>
            {itens.map((item) => (
              <Linha key={item.id}>
                <Celula>
                  {item.chamado_id ? (
                    <Link to={`/admin/chamados/${item.chamado_id}`}>
                      #{item.numero} {item.titulo}
                    </Link>
                  ) : (
                    item.titulo
                  )}
                </Celula>
                <Celula>{item.organizacao ?? "—"}</Celula>
                <Celula>{situacaoDoItem(item)}</Celula>
                <Celula>{formatarInstante(item.em) ?? "—"}</Celula>
              </Linha>
            ))}
          </Corpo>
        </Tabela>
      )}
    </div>
  );
}
